export class EmergencyTaskAssignee {

  incidentId : string;
  assigneeId : string;
  emergencyTaskId : number;
}
